import React from 'react';

import Label from 'components/form/Label/Label';
import { Link } from 'components/navigation/Link/Link';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Image } from 'components/Image/Image';
import { Row } from 'components/Containers/Row/Row';
import { AUTO_LOAN_VERTICAL } from 'types/mrph.vertical.constants';
import FrequentlyAskedQuestions from 'components/FrequentlyAskedQuestions/FrequentlyAskedQuestions';
import { HOME_LOAN_VERTICAL } from 'types/marketplaceTiles.constants';

const frequentlyAskedHomeQuestion = [
  {
    question: 'How much mortgage can I afford?',
    answer:
      'The mortgage amount you can afford depends on several factors such as your income, expenses, credit score, down payment, and debt-to-income ratio. A general rule of thumb is that your monthly mortgage payment should not exceed 30% of your gross monthly income. It is important to ensure that you can manage your mortgage payments comfortably while meeting other financial obligations.',
  },
  {
    question: 'What are the different types of mortgages?',
    answer:
      'Mortgage types include fixed-rate mortgages (FRM) with a consistent interest rate, adjustable-rate mortgages (ARM) with periodically adjusting interest rates, Federal Housing Administration (FHA) loans for low down-payments, Department of Veteran Affairs (VA) loans for eligible veterans, United States Department of Agriculture (USDA) loans for rural homebuyers, and jumbo loans for high-value properties. Each type has its own eligibility requirements, conditions and benefits.',
  },
  {
    question:
      'What are the benefits of a good credit score when applying for a mortgage?',
    answer:
      'A good credit score increases the likelihood of loan approval as lenders view borrowers with higher scores as less risky. A higher credit score may result in lower interest rates, which can save you thousands of dollars over the term of the mortgage. Lenders may offer more favorable loan terms such as lower fees and flexible repayment options, to borrowers with good credit. Finally, a good credit score can expand your borrowing capacity, allowing you to qualify for higher loan amounts and potentially purchase a more desirable property.',
  },
];

const frequentlyAskedCarQuestion = [
  {
    question: 'How much can I afford to borrow for a car?',
    answer:
      'The amount you can borrow for a car depends on your income, expenses, credit score and desired monthly payment. A good rule of thumb is your total vehicle expenses including loan payments should not exceed 15% of our monthly income. However, you must considered your individual circumstances and expenses.',
  },
  {
    question: 'What are the different types of car loans?',
    answer:
      'Car loan types include new car loans for brand  new cars, used car loans for pre-owned vehicles, secured loans requiring collateral, unsecured loans without collateral, loans for people with lower credit scores and refinancing options to replace existing loans. The loan you can get depends on your requirements and financial situation.',
  },
  {
    question:
      'What are the benefits of a good credit score when applying for a car loan?',
    answer:
      'A good credit score increases the likelihood of loan approval. It can help secure a lower interest rate, possibly saving money over the loan term. Higher credit scores may result in more favorable loan terms, for example, longer repayment periods or lower down-payment requirements. Additionally, a good credit score can open the door to a wider range of lenders and loan options, giving you more choice in your car financing options.',
  },
];

const actionsYouCanTake = {
  homeLoan: {
    title: 'Looking for a mortgage loan?',
    subtitle:
      'Know your options by comparing interest rates and monthly payments.',
    takeAction: {
      module: 'HomeLoans',
      title: 'Explore home loans',
      icon: 'exploreHomeLoans',
      link: '/offers?vertical=HOME_LOAN&tab=infoAndTools',
      vertical: HOME_LOAN_VERTICAL,
      clickTile: 'Explore home loans',
    },
  },
  autoLoan: {
    title: 'Want a new car?',
    subtitle:
      'Know your options by comparing interest rates and monthly payments.',
    takeAction: {
      module: 'AutoLoans',
      title: 'Explore auto loans',
      icon: 'exploreAutoLoans',
      link: '/offers?vertical=AUTO_LOAN',
      vertical: AUTO_LOAN_VERTICAL,
      clickTile: 'Explore auto loans',
    },
  },
};

const TakeActionBox = props => {
  const { title, subtitle, takeAction, listLinkCallback } = props;

  return (
    <>
      <Label className={'H5 margB16'}>{title}</Label>
      <Label className={'Body-1 mBody-2   margB16'}>{subtitle}</Label>
      <Link
        to={takeAction.link}
        onClickCallback={listLinkCallback}
        link={takeAction?.description}
        Vertical={takeAction?.vertical}
        clickTile={takeAction.clickTile}
      >
        <FlexContainer
          className={
            'bgGray0 format100 margB16 border-rad10px  padTB8 padLR16 align-items-center justify-between'
          }
          style={{ height: '72px' }}
        >
          <Image className={takeAction?.icon} />

          <div className="margL14" style={{ width: '330px' }}>
            <Label className={'subTitle1 mSubtitle-1 secondary_text_light'}>
              {takeAction?.title}
            </Label>
          </div>

          <Image className={'rightArrowIcon'} />
        </FlexContainer>
      </Link>
    </>
  );
};

const AlertInquiryInfo = props => {
  let questions = frequentlyAskedHomeQuestion;
  let offer = actionsYouCanTake.homeLoan;

  if (props?.isAutoLoanInquiryAlert) {
    questions = frequentlyAskedCarQuestion;
    offer = actionsYouCanTake.autoLoan;
  }

  return (
    <>
      <Row
        className="padT24 padb0 bgWhite"
        datatestid={`${props?.datatestid}-action-block`}
      >
        <div>
          <div className="text-20 bold">
            <TakeActionBox {...offer} {...props} />
          </div>
        </div>
      </Row>
      <div className="padTB4 bgGrey005"></div>
      <Row className="padTB24 bgWhite">
        <FrequentlyAskedQuestions frequentlyAskedQuestion={questions} />
      </Row>
    </>
  );
};

export default AlertInquiryInfo;
